module.exports = __webpack_public_path__ + "img/face16.d16e999e.jpg";